import Swal from 'sweetalert2';
import './leaseKindPrompt.css';

const escapeHtml = (s) =>
  String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

const ICON_RENEWAL =
  '<svg class="lk-choice__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M21 12a9 9 0 0 1-15.5 6.2M3 12a9 9 0 0 1 15.5-6.2"/><path d="M21 3v5h-5M3 21v-5h5"/></svg>';
const ICON_NEW =
  '<svg class="lk-choice__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/><path d="M12 12v6M9 15h6"/></svg>';

const choice = (icon, title, hint) =>
  `${icon}<span class="lk-choice__text"><strong>${title}</strong><small>${hint}</small></span>`;

/**
 * Manage Lease on an occupied unit (owner, 2026-10-01): is the lease a renewal for the
 * resident already there, or a new resident? The answer drives the Renewed / Rented
 * tile. Resolves "RENEWAL", "NEW", or null when the manager backs out.
 */
export const askLeaseKind = async ({ unitNo, tenantName }) => {
  const who = escapeHtml(tenantName);
  const result = await Swal.fire({
    title: 'New lease or renewal?',
    html:
      `<div class="lk-unit">Unit ${escapeHtml(unitNo)} · <b>${who}</b></div>` +
      '<div class="lk-note">Your answer decides whether this lease counts as <b>Renewed</b> or <b>Rented</b> on the Mastersheet.</div>',
    showConfirmButton: true,
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: choice(ICON_RENEWAL, 'Renewal', `${who} is staying`),
    denyButtonText: choice(ICON_NEW, 'New Lease', 'A new resident is moving in'),
    cancelButtonText: 'Cancel',
    // Enter must never pick an answer by accident: focus starts on Cancel.
    focusCancel: true,
    buttonsStyling: false,
    customClass: {
      popup: 'lk-popup',
      title: 'lk-title',
      htmlContainer: 'lk-body',
      actions: 'lk-actions',
      confirmButton: 'lk-choice lk-choice--renewal',
      denyButton: 'lk-choice lk-choice--new',
      cancelButton: 'lk-cancel',
    },
  });
  if (result.isConfirmed) return 'RENEWAL';
  if (result.isDenied) return 'NEW';
  return null;
};
